import { DrawingDto, Quote, QuoteStatus, QuoteType } from "src/api-service";
import { AppError } from "../../app-store-error.types";
import { CatalogTree, DrawingUpload } from "src/app/shared/interfaces/interfaces";
import { QuoteValidation, emptyQuoteValidation } from "./validation/validation.types";
import { QuotesState, initialQuotesState } from "./quotes/quotes.state";
import { ArticlesFilterState, initialArticlesFilterState, ProductCatalogFilterState, initialProductCatalogFilterState } from "./articles/articles.state";

export { ExpandCommand } from "./articles/articles.state";

// ============================================================================
// QUOTE STATE
// ============================================================================

export interface QuoteState extends Quote {
    // Version
    selectedVersion: number;
    // Selection
    selectedProductGroupIds: number[];
    selectedArticleIds: number[];
    expandedGroupIds: number[];
    // Loading & Error
    loading: Record<string, boolean>;
    error: AppError | null;
    errorFetchingQuote: boolean;
    // Validation & Dialogs
    validation: QuoteValidation;
    showRequirementsDialog: boolean;
    // Drawing
    drawing: DrawingDto | undefined;
    drawingUploads: DrawingUpload[];
    // Catalogs & Articles
    catalogs: CatalogTree[];
    catalogFilter: ProductCatalogFilterState;
    articlesFilter: ArticlesFilterState;
    // Quotes List
    quotes: QuotesState;
}

// ============================================================================
// INITIAL STATE
// ============================================================================

export const initialQuoteState: QuoteState = {
    // Quote (API)
    id: 0,
    displayId: 0,
    status: QuoteStatus.Archived,
    type: QuoteType.Regular,
    created: undefined,
    updated: undefined,
    sourceQuoteId: undefined,
    attioDealRecordId: undefined,
    attioDealUrl: undefined,
    attioQuoteUrl: undefined,
    hideBrands: false,
    comments: [],
    customer: undefined,
    salesInfo: undefined,
    deliveryInfo: undefined,
    opportunity: undefined,
    leasingInfo: undefined,
    versions: undefined,
    vendorInquiries: [],
    isLocked: false,
    isUnderReview: false,
    isValidSalesSupportPerson: false,
    isExpired: false,
    hasCompletedDrawing: false,
    // Version
    selectedVersion: 0,
    // Selection
    selectedProductGroupIds: [],
    selectedArticleIds: [],
    expandedGroupIds: [],
    // Loading & Error
    loading: {},
    error: null,
    errorFetchingQuote: false,
    // Validation & Dialogs
    validation: emptyQuoteValidation,
    showRequirementsDialog: false,
    // Drawing
    drawing: undefined,
    drawingUploads: [],
    // Catalogs & Articles
    catalogs: [],
    catalogFilter: initialProductCatalogFilterState,
    articlesFilter: initialArticlesFilterState,
    // Quotes List
    quotes: initialQuotesState,
};
